import { render } from "./doctor-appointment.vue?vue&type=template&id=1b38d923&scoped=true"
import script from "./doctor-appointment.vue?vue&type=script&lang=js"
export * from "./doctor-appointment.vue?vue&type=script&lang=js"

import "./doctor-appointment.vue?vue&type=style&index=0&id=1b38d923&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b38d923"]])

export default __exports__